<template>
  <!--  <el-row>-->
  <!--    <el-col :span="24">-->
<!--  <el-breadcrumb separator-class="el-icon-arrow-right">-->
<!--    <el-breadcrumb-item :to="{ path: '/' }">综合治理成果管理</el-breadcrumb-item>-->
<!--    <el-breadcrumb-item>成果上报</el-breadcrumb-item>-->
<!--    <el-breadcrumb-item>软件工区</el-breadcrumb-item>-->
<!--  </el-breadcrumb>-->
  <!--    </el-col>-->
  <!--  </el-row>-->
  <!--  <el-row style="width: 100%">-->
  <table-view
      check-selectablefield="sh_stat"
      :selectable="true"
      :send-verify="true"
      :show-grid-cfg="false"
      :send-verify-check-url="sendVerifyCheckUrl"
      :send-verify-url="sendVerifyUrl"
      :upload-status="uploadStatus"
      :upload-type="uploadType"
      :template-info="templateInfo"/>
  <!--  </el-row>-->
</template>

<script>
import axios from "axios";
import TableView from "@/components/tableView";

export default {
  mounted() {
    this.knowThis();
    console.log(1)
  },
  methods: {
    async knowThis(){
      let _this = this;
      console.log(this.$route.name)
      let localIpStr = localStorage.getItem("userLocalIP");
      if (localIpStr == null) localIpStr = "127.0.0.1";
      let jwtSession = localStorage.getItem("lyqtJwt");
      if (jwtSession == null) jwtSession = "";
      await axios({
        url:process.env.VUE_APP_SERVER + "/dataprovider/systemdata/module/route/template/" + `${this.$route.name}`,
        headers: {
          "Authorization": "Bearer " + jwtSession,
          "userIP": localIpStr
        },
        method: 'GET'})
          .then(res=>{
            console.log("template");
            console.log(res.data.content)
            _this.templateInfo = res.data.content.pages[0];
            _this.templateInfo.moduleid=res.data.content.moduleid;
            _this.templateInfo.modulename=res.data.content.modulename;
          }).catch(err=>{
            console.log(err)
          })
    },
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    uploadFile(file,fileList){
      console.log(1,file,fileList);
      alert(file);
    }
    // handleChange(file,fileList){
    //   console.log(1,file);
    //   console.log(2,fileList)
    //   console.log(3,this.fileList)
    // }
  },
  data() {
    return {
      templateInfo:{},
      tableData: [{
        SCSJ: '2001-12-10 11:20:12',
        TJSJ: '2001-12-10 16:20:32',
        CNT: '7',
        STAT: '已驳回',
        SHJL: '查看',
        OP: '查看,送审,删除'
      }],
      uploadStatus:1,
      uploadType:"Gq",
      menuVisible: false,
      sendVerifyCheckUrl:process.env.VUE_APP_SERVER + "/dataprovider/businessdata/checkYJCGList",
      sendVerifyUrl:process.env.VUE_APP_SERVER + "/dataprovider/businessdata/sendResultListToVerify"
      // uploadUrl:process.env.VUE_APP_SERVER + "/fileprocesser/uploadgq"
    }
  },
  components: {
    TableView
    // docFileUploader
  },
  watch:{
    $route:{
      handler(val,oldval){
        console.log("老",val);//新路由信息
        console.log("新",oldval);//老路由信息
        this.knowThis();
      },
      deep:true
    }
  }
}
</script>